import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useMemo, useState } from 'react'
import { getFciFundingHistory } from 'services'
import { PlainTable } from 'stories/components'
import { setLoanNumber } from 'utils/setLoanNumber'

import { renderFCIvalue } from '../constants'
import { tableBodyData, tableHeaders } from './constants'

export const FciFundingHistory = ({ servicerNo = 0 }: { servicerNo?: number }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Array<Record<string, any>>>([])

  const initData = async () => {
    setLoading(true)
    const res = await getFciFundingHistory(servicerNo)
    setData(res || [])
    setLoading(false)
  }

  useEffect(() => {
    setLoanNumber()
    initData()
  }, [])

  const tableData = useMemo(() => {
    return data.map((item) => {
      return Object.keys(tableBodyData).map((key: string) => renderFCIvalue(item[key], tableBodyData[key]))
    })
  }, [data])

  return (
    <div className="fci-loan-detail-container px-2">
      <div className="max-w-screen-2xl m-auto">
        <div className="relative bg-white mt-6">
          <LayoutLoading show={loading} />
          <PlainTable header={tableHeaders} data={tableData} hasPagination />
        </div>
      </div>
    </div>
  )
}
